import { contacts as userContacts } from "../static-data";

export default function contacts(state = userContacts) {
  return state;
}
